import { handleActions } from 'redux-actions';

import {
  editInvoice,
  removeInvoice,
  updateInvoices,
} from './actions';

export default handleActions(
  {
    [editInvoice]: (state, { payload: { data } }) => {
      const { id, ...rest } = data;
  
      return {
        ...state,
        [id]: {
          ...state[id],
          ...rest,
        },
      };
    },
    [removeInvoice]: (state, { payload: { data: { id, deletedAt, deletedBy } } }) => ({
      ...state,
      [id]: {
        ...state[id],
        archived: true,
        deletedAt,
        deletedBy,
      },
    }),
    [updateInvoices]: (state, { payload: { data } }) => ({
      ...state,
      ...data,
    }),
  },
  {},
);
